module.exports = __webpack_public_path__ + "static/cse-44490ab51ba470f03b8536db919e851d.svg";